import { atom } from "recoil";

export const termListState = atom({
  key: "termListState",
  default: [],
});
